import { render, staticRenderFns } from "./file-sharing-status.vue?vue&type=template&id=17995646&scoped=true"
import script from "./file-sharing-status.vue?vue&type=script&lang=js"
export * from "./file-sharing-status.vue?vue&type=script&lang=js"
import style0 from "./file-sharing-status.vue?vue&type=style&index=0&id=17995646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17995646",
  null
  
)

export default component.exports